import { render, staticRenderFns } from "./LeaveManager.vue?vue&type=template&id=42bed3aa"
import script from "./LeaveManager.vue?vue&type=script&lang=js"
export * from "./LeaveManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports